export enum NavItemId {
  Dashboard,
  Create,
  Customers,
  Products,
  Themes,
  Defaults,
  BudBot,
  Settings,
  Profile,
  SignOut
}
